import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import UserIcon from '@wix/da-ds/pkg/Icons/User';
import { useCurrentUser } from '../../../../../../utils/hooks/useCurrentUser';
import UserAvatar from '../../../../../../User/Avatar';
import { UserMenuContext } from '../../UserMenuContext';
import userMenuStyles from '../../UserMenuMobile.scss';

export interface Props {}

const UserMenuAvatar: React.FC<Props> = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const { isOpen: isUserMenuOpen, toggleUserMenu } =
    useContext(UserMenuContext);

  return (
    <>
      {currentUser ? (
        <PlainButtonOrLink
          onClick={toggleUserMenu}
          aria-label={t('siteHeader.userMenu.a11y.label')}
          aria-expanded={isUserMenuOpen}
          tabIndex={isUserMenuOpen ? 0 : -1}
        >
          <UserAvatar
            user={currentUser}
            size={32}
            className={userMenuStyles['avatar']}
            withLink={false}
            withTooltip={false}
            enableLazyLoad={false}
          />
        </PlainButtonOrLink>
      ) : (
        <PlainButtonOrLink
          onClick={toggleUserMenu}
          className={classnames(
            userMenuStyles['avatar-wrapper'],
            isUserMenuOpen && userMenuStyles['with-menu-open']
          )}
          aria-label={t('siteHeader.userMenu.a11y.label')}
          aria-expanded={isUserMenuOpen}
          tabIndex={isUserMenuOpen ? 0 : -1}
        >
          <UserIcon
            className={classnames(
              userMenuStyles['anon-user-icon'],
              isUserMenuOpen && userMenuStyles['is-dark']
            )}
            size={IconSize.MEDIUM}
            withPadding
          />
        </PlainButtonOrLink>
      )}
    </>
  );
};
UserMenuAvatar.displayName = 'UserMenuAvatar';

export default UserMenuAvatar;
